import { render } from "./IconEarners.vue?vue&type=template&id=7d14a553"
const script = {}

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__